export enum IotProvider {
  Calirom = 'CALIROM',
  Orange = 'ORANGE',
  OrangeSecure = 'ORANGE_SECURE',
  NookaPoc = 'NOOKA_POC',
  NookaLive = 'NOOKA_LIVE',
  Coniferis = 'CONIFERIS'
}
